import * as Types from '../../../generated/graphql_types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type NucleusDatasetInfoQueryVariables = Types.Exact<{
  datasetId: Types.Scalars['ID'];
}>;

export type NucleusDatasetInfoQuery = {
  readonly __typename?: 'RootQuery';
  readonly viewer: { readonly __typename: 'ScaleUser'; readonly id: string } | null;
  readonly nucleusDatasetById: {
    readonly __typename: 'NucleusDataset';
    readonly track_count: number;
    readonly id: string;
    readonly name: string;
    readonly created_at: string;
    readonly delete_status: Types.DatasetDeleteStatus | null;
    readonly is_public: boolean;
    readonly is_indexed_image: boolean | null;
    readonly is_indexed_object: boolean | null;
    readonly is_scene: boolean;
    readonly is_label_linked: boolean | null;
    readonly rapid_project_id: string | null;
    readonly invalid_task_types: ReadonlyArray<string> | null;
    readonly sliceCount: number | null;
    readonly itemCount: number | null;
    readonly license_id: string | null;
    readonly viewer_is_owner: boolean | null;
    readonly viewer_can_edit: boolean | null;
    readonly type: Types.DatasetTypeEnum;
    readonly has_clip_index: boolean | null;
    readonly scene_distinct_sensor_names: ReadonlyArray<string> | null;
    readonly hasGeoData: boolean | null;
    readonly tags: ReadonlyArray<string>;
    readonly model_runs: ReadonlyArray<{
      readonly __typename: 'NucleusModelRun';
      readonly id: string;
      readonly name: string | null;
      readonly started_at: string;
      readonly status: string | null;
      readonly model_id: string;
    }> | null;
    readonly colorScheme: {
      readonly __typename?: 'NucleusDatasetColorSchemeType';
      readonly scheme: any;
    } | null;
    readonly searchIndexes: ReadonlyArray<{
      readonly __typename: 'NucleusSearchIndex';
      readonly id: string;
      readonly status: Types.SearchIndexStatus;
      readonly index_level: Types.SearchIndexLevel;
      readonly index_type: Types.SearchIndexType;
      readonly is_primary: boolean;
      readonly embedding_type: string;
      readonly embedding_dim: number;
    }>;
    readonly config: {
      readonly __typename?: 'NucleusDatasetConfigType';
      readonly productConfig: ReadonlyArray<{
        readonly __typename?: 'ConfigItemType';
        readonly path: string;
        readonly displayType: string | null;
        readonly label: string | null;
      } | null> | null;
      readonly variantConfig: ReadonlyArray<{
        readonly __typename?: 'ConfigItemType';
        readonly path: string;
        readonly displayType: string | null;
        readonly label: string | null;
      } | null> | null;
      readonly variantMergeConfig: ReadonlyArray<{
        readonly __typename?: 'ConfigItemType';
        readonly path: string;
        readonly displayType: string | null;
        readonly label: string | null;
      } | null> | null;
    } | null;
    readonly pending_jobs: ReadonlyArray<{
      readonly __typename: 'NucleusJob';
      readonly id: string;
      readonly job_type: string | null;
      readonly created_at: string;
      readonly ended_at: string | null;
      readonly status: string;
      readonly user_id: string;
      readonly completed_steps: number | null;
      readonly total_steps: number | null;
      readonly last_updated: string | null;
      readonly archived: boolean;
      readonly metadata_public: any | null;
      readonly progress_counters: any | null;
      readonly user: {
        readonly __typename: 'ScaleUser';
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
      } | null;
      readonly dataset: {
        readonly __typename: 'NucleusDataset';
        readonly id: string;
        readonly name: string;
      } | null;
    }> | null;
  } | null;
};

export type NucleusDatasetSchemaQueryVariables = Types.Exact<{
  datasetId: Types.Scalars['ID'];
}>;

export type NucleusDatasetSchemaQuery = {
  readonly __typename?: 'RootQuery';
  readonly nucleusDatasetById: {
    readonly __typename: 'NucleusDataset';
    readonly id: string;
    readonly schema: any | null;
  } | null;
};

export type NucleusDatasetMinimalInfoQueryVariables = Types.Exact<{
  datasetId: Types.Scalars['ID'];
}>;

export type NucleusDatasetMinimalInfoQuery = {
  readonly __typename?: 'RootQuery';
  readonly nucleusDatasetById: {
    readonly __typename: 'NucleusDataset';
    readonly id: string;
    readonly name: string;
    readonly created_at: string;
    readonly delete_status: Types.DatasetDeleteStatus | null;
    readonly is_public: boolean;
    readonly is_indexed_image: boolean | null;
    readonly is_indexed_object: boolean | null;
    readonly is_scene: boolean;
    readonly is_label_linked: boolean | null;
    readonly rapid_project_id: string | null;
    readonly invalid_task_types: ReadonlyArray<string> | null;
    readonly sliceCount: number | null;
    readonly itemCount: number | null;
    readonly license_id: string | null;
    readonly viewer_is_owner: boolean | null;
    readonly viewer_can_edit: boolean | null;
    readonly type: Types.DatasetTypeEnum;
    readonly has_clip_index: boolean | null;
    readonly scene_distinct_sensor_names: ReadonlyArray<string> | null;
    readonly hasGeoData: boolean | null;
    readonly tags: ReadonlyArray<string>;
    readonly colorScheme: {
      readonly __typename?: 'NucleusDatasetColorSchemeType';
      readonly scheme: any;
    } | null;
    readonly searchIndexes: ReadonlyArray<{
      readonly __typename: 'NucleusSearchIndex';
      readonly id: string;
      readonly status: Types.SearchIndexStatus;
      readonly index_level: Types.SearchIndexLevel;
      readonly index_type: Types.SearchIndexType;
      readonly is_primary: boolean;
      readonly embedding_type: string;
      readonly embedding_dim: number;
    }>;
    readonly config: {
      readonly __typename?: 'NucleusDatasetConfigType';
      readonly productConfig: ReadonlyArray<{
        readonly __typename?: 'ConfigItemType';
        readonly path: string;
        readonly displayType: string | null;
        readonly label: string | null;
      } | null> | null;
      readonly variantConfig: ReadonlyArray<{
        readonly __typename?: 'ConfigItemType';
        readonly path: string;
        readonly displayType: string | null;
        readonly label: string | null;
      } | null> | null;
      readonly variantMergeConfig: ReadonlyArray<{
        readonly __typename?: 'ConfigItemType';
        readonly path: string;
        readonly displayType: string | null;
        readonly label: string | null;
      } | null> | null;
    } | null;
    readonly pending_jobs: ReadonlyArray<{
      readonly __typename: 'NucleusJob';
      readonly id: string;
      readonly job_type: string | null;
      readonly created_at: string;
      readonly ended_at: string | null;
      readonly status: string;
      readonly user_id: string;
      readonly completed_steps: number | null;
      readonly total_steps: number | null;
      readonly last_updated: string | null;
      readonly archived: boolean;
      readonly metadata_public: any | null;
      readonly progress_counters: any | null;
      readonly user: {
        readonly __typename: 'ScaleUser';
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
      } | null;
      readonly dataset: {
        readonly __typename: 'NucleusDataset';
        readonly id: string;
        readonly name: string;
      } | null;
    }> | null;
  } | null;
};

export type DatasetInfoFragment = {
  readonly __typename: 'NucleusDataset';
  readonly id: string;
  readonly name: string;
  readonly created_at: string;
  readonly delete_status: Types.DatasetDeleteStatus | null;
  readonly is_public: boolean;
  readonly is_indexed_image: boolean | null;
  readonly is_indexed_object: boolean | null;
  readonly is_scene: boolean;
  readonly is_label_linked: boolean | null;
  readonly rapid_project_id: string | null;
  readonly invalid_task_types: ReadonlyArray<string> | null;
  readonly sliceCount: number | null;
  readonly itemCount: number | null;
  readonly license_id: string | null;
  readonly viewer_is_owner: boolean | null;
  readonly viewer_can_edit: boolean | null;
  readonly type: Types.DatasetTypeEnum;
  readonly has_clip_index: boolean | null;
  readonly scene_distinct_sensor_names: ReadonlyArray<string> | null;
  readonly hasGeoData: boolean | null;
  readonly tags: ReadonlyArray<string>;
  readonly colorScheme: {
    readonly __typename?: 'NucleusDatasetColorSchemeType';
    readonly scheme: any;
  } | null;
  readonly searchIndexes: ReadonlyArray<{
    readonly __typename: 'NucleusSearchIndex';
    readonly id: string;
    readonly status: Types.SearchIndexStatus;
    readonly index_level: Types.SearchIndexLevel;
    readonly index_type: Types.SearchIndexType;
    readonly is_primary: boolean;
    readonly embedding_type: string;
    readonly embedding_dim: number;
  }>;
  readonly config: {
    readonly __typename?: 'NucleusDatasetConfigType';
    readonly productConfig: ReadonlyArray<{
      readonly __typename?: 'ConfigItemType';
      readonly path: string;
      readonly displayType: string | null;
      readonly label: string | null;
    } | null> | null;
    readonly variantConfig: ReadonlyArray<{
      readonly __typename?: 'ConfigItemType';
      readonly path: string;
      readonly displayType: string | null;
      readonly label: string | null;
    } | null> | null;
    readonly variantMergeConfig: ReadonlyArray<{
      readonly __typename?: 'ConfigItemType';
      readonly path: string;
      readonly displayType: string | null;
      readonly label: string | null;
    } | null> | null;
  } | null;
  readonly pending_jobs: ReadonlyArray<{
    readonly __typename: 'NucleusJob';
    readonly id: string;
    readonly job_type: string | null;
    readonly created_at: string;
    readonly ended_at: string | null;
    readonly status: string;
    readonly user_id: string;
    readonly completed_steps: number | null;
    readonly total_steps: number | null;
    readonly last_updated: string | null;
    readonly archived: boolean;
    readonly metadata_public: any | null;
    readonly progress_counters: any | null;
    readonly user: {
      readonly __typename: 'ScaleUser';
      readonly id: string;
      readonly firstName: string | null;
      readonly lastName: string | null;
    } | null;
    readonly dataset: {
      readonly __typename: 'NucleusDataset';
      readonly id: string;
      readonly name: string;
    } | null;
  }> | null;
};

export type SearchIndexConfigFragment = {
  readonly __typename: 'NucleusSearchIndex';
  readonly id: string;
  readonly status: Types.SearchIndexStatus;
  readonly index_level: Types.SearchIndexLevel;
  readonly index_type: Types.SearchIndexType;
  readonly is_primary: boolean;
  readonly embedding_type: string;
  readonly embedding_dim: number;
};

export type DatasetConfigFragment = {
  readonly __typename?: 'NucleusDatasetConfigType';
  readonly productConfig: ReadonlyArray<{
    readonly __typename?: 'ConfigItemType';
    readonly path: string;
    readonly displayType: string | null;
    readonly label: string | null;
  } | null> | null;
  readonly variantConfig: ReadonlyArray<{
    readonly __typename?: 'ConfigItemType';
    readonly path: string;
    readonly displayType: string | null;
    readonly label: string | null;
  } | null> | null;
  readonly variantMergeConfig: ReadonlyArray<{
    readonly __typename?: 'ConfigItemType';
    readonly path: string;
    readonly displayType: string | null;
    readonly label: string | null;
  } | null> | null;
};

export type ConfigItemFragment = {
  readonly __typename?: 'ConfigItemType';
  readonly path: string;
  readonly displayType: string | null;
  readonly label: string | null;
};

export type ModelRunInfoFragment = {
  readonly __typename: 'NucleusModelRun';
  readonly id: string;
  readonly name: string | null;
  readonly started_at: string;
  readonly status: string | null;
  readonly model_id: string;
};

export type JobInfoFragment = {
  readonly __typename: 'NucleusJob';
  readonly id: string;
  readonly job_type: string | null;
  readonly created_at: string;
  readonly ended_at: string | null;
  readonly status: string;
  readonly user_id: string;
  readonly completed_steps: number | null;
  readonly total_steps: number | null;
  readonly last_updated: string | null;
  readonly archived: boolean;
  readonly metadata_public: any | null;
  readonly progress_counters: any | null;
  readonly user: {
    readonly __typename: 'ScaleUser';
    readonly id: string;
    readonly firstName: string | null;
    readonly lastName: string | null;
  } | null;
  readonly dataset: {
    readonly __typename: 'NucleusDataset';
    readonly id: string;
    readonly name: string;
  } | null;
};

export const SearchIndexConfigFragmentDoc = gql`
  fragment searchIndexConfig on NucleusSearchIndex {
    __typename
    id
    status
    index_level
    index_type
    is_primary
    embedding_type
    embedding_dim
  }
`;
export const ConfigItemFragmentDoc = gql`
  fragment configItem on ConfigItemType {
    path
    displayType
    label
  }
`;
export const DatasetConfigFragmentDoc = gql`
  fragment datasetConfig on NucleusDatasetConfigType {
    productConfig {
      ...configItem
    }
    variantConfig {
      ...configItem
    }
    variantMergeConfig {
      ...configItem
    }
  }
  ${ConfigItemFragmentDoc}
`;
export const JobInfoFragmentDoc = gql`
  fragment jobInfo on NucleusJob {
    __typename
    id
    user {
      __typename
      id
      firstName
      lastName
    }
    job_type
    created_at
    ended_at
    status
    user_id
    completed_steps
    total_steps
    last_updated
    archived
    metadata_public
    progress_counters
    dataset {
      __typename
      id
      name
    }
  }
`;
export const DatasetInfoFragmentDoc = gql`
  fragment datasetInfo on NucleusDataset {
    __typename
    id
    name
    created_at
    delete_status
    is_public
    is_indexed_image
    is_indexed_object
    is_scene
    is_label_linked
    rapid_project_id
    invalid_task_types
    sliceCount
    itemCount
    license_id
    viewer_is_owner
    viewer_can_edit
    type
    colorScheme {
      scheme
    }
    searchIndexes {
      ...searchIndexConfig
    }
    config {
      ...datasetConfig
    }
    pending_jobs {
      ...jobInfo
    }
    has_clip_index
    scene_distinct_sensor_names
    hasGeoData
    tags
  }
  ${SearchIndexConfigFragmentDoc}
  ${DatasetConfigFragmentDoc}
  ${JobInfoFragmentDoc}
`;
export const ModelRunInfoFragmentDoc = gql`
  fragment modelRunInfo on NucleusModelRun {
    __typename
    id
    name
    started_at
    status
    model_id
  }
`;
export const NucleusDatasetInfoDocument = gql`
  query NucleusDatasetInfo($datasetId: ID!) {
    viewer {
      __typename
      id
    }
    nucleusDatasetById(id: $datasetId) {
      ...datasetInfo
      model_runs {
        ...modelRunInfo
      }
      track_count
    }
  }
  ${DatasetInfoFragmentDoc}
  ${ModelRunInfoFragmentDoc}
`;

export function useNucleusDatasetInfoQuery(
  options: Omit<Urql.UseQueryArgs<NucleusDatasetInfoQueryVariables>, 'query'>,
) {
  return Urql.useQuery<NucleusDatasetInfoQuery, NucleusDatasetInfoQueryVariables>({
    query: NucleusDatasetInfoDocument,
    ...options,
  });
}
export const NucleusDatasetSchemaDocument = gql`
  query NucleusDatasetSchema($datasetId: ID!) {
    nucleusDatasetById(id: $datasetId) {
      __typename
      id
      schema
    }
  }
`;

export function useNucleusDatasetSchemaQuery(
  options: Omit<Urql.UseQueryArgs<NucleusDatasetSchemaQueryVariables>, 'query'>,
) {
  return Urql.useQuery<NucleusDatasetSchemaQuery, NucleusDatasetSchemaQueryVariables>({
    query: NucleusDatasetSchemaDocument,
    ...options,
  });
}
export const NucleusDatasetMinimalInfoDocument = gql`
  query NucleusDatasetMinimalInfo($datasetId: ID!) {
    nucleusDatasetById(id: $datasetId) {
      ...datasetInfo
    }
  }
  ${DatasetInfoFragmentDoc}
`;

export function useNucleusDatasetMinimalInfoQuery(
  options: Omit<Urql.UseQueryArgs<NucleusDatasetMinimalInfoQueryVariables>, 'query'>,
) {
  return Urql.useQuery<NucleusDatasetMinimalInfoQuery, NucleusDatasetMinimalInfoQueryVariables>({
    query: NucleusDatasetMinimalInfoDocument,
    ...options,
  });
}
